import { makeRequest } from 'utils/requestLogger';

export default (discussion_id, user_id) => {
  return makeRequest('put', `/api/live_discussions/${discussion_id}/tap_out_of_queue/${user_id}`);
};




// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/queue/tapOut.js